import { Component } from "@angular/core";
import { CustomMessage } from "../../model/custom-message.model";
import { StatusConfigService } from "../../services/status-config.service";
import { NgbDropdownModule, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomMessageFormComponent } from "../custom-message-form/custom-message-form.component";
import { ConfirmationDialogService } from "src/app/shared/confirmation-dialog/confirmation-dialog.service";
import { AuthService } from "src/app/core/services/auth/auth.service";
import { ToastService } from "src/app/shared/toasts/toast-service";

@Component({
  selector: "app-custom-message-list",
  templateUrl: "./custom-message-list.component.html",
  styleUrl: "./custom-message-list.component.scss",
})
export class CustomMessageListComponent {
  customMessages: CustomMessage[] = [];
  isLoading: boolean = true;

  // permissões
  podeEditar: boolean = false;

  constructor(
    private statusConfigService: StatusConfigService,
    private modalService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService,
    private authService: AuthService,
    private toastService: ToastService
  ) {}

  openNewmessageModal(customMessage?: CustomMessage): void {
    const modalRef = this.modalService.open(CustomMessageFormComponent);
    if (customMessage) {
      modalRef.componentInstance.customMessage = customMessage;
    }
    modalRef.closed.subscribe({
      next: () => {
        this.getCustomMessages();

        this.toastService.show("Mensagem registrada com sucesso!", {
          classname: "bg-success text-light",
        });

        setTimeout(() =>{
          window.location.reload();
        }, 3000);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  getCustomMessages() {
    this.statusConfigService.getCustomMessages().subscribe({
      next: (customMessages) => {
        this.customMessages = customMessages;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  ngOnInit(): void {
    
    this.getCustomMessages();

    this.permissaoAdicionarUsuario();
  }

  onDeleteCustomMessage(customMessage: CustomMessage) {
    this.confirmationDialogService
      .confirm(
        "Confirma a exclusão da mensagem?",
        "Essa ação não poderá ser desfeita.",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.statusConfigService
            .deleteCustomMessage(customMessage.id)
            .subscribe({
              next: () => {
                this.getCustomMessages();

                this.toastService.show("Mensagem excluída com sucesso!", {
                  classname: "bg-success text-light",
                });

                setTimeout(() =>{
                  window.location.reload();
                }, 3000);
              },
              error: (error) => {
                this.toastService.show("Erro ao excuir mensagem!", {
                  classname: "bg-danger text-light",
                });
                console.error(error);
              },
            });
        }
      });
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Configuracoes', 'Editar')
  }
}
